import React from 'react';
import { Box, Button, Container, Stack, Typography } from '@mui/material';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';

const AssignedTransactionsHeader = ({ onRefresh, isRefreshing }) => (
    <Box
        sx={{
            borderBottom: '1px solid',
            borderColor: 'divider',
            background: 'linear-gradient(135deg, rgba(255,165,0,0.12) 0%, rgba(0,0,0,0.06) 100%)',
            py: { xs: 3, md: 4 },
        }}
    >
        <Container maxWidth="lg">
            <Stack
                direction={{ xs: 'column', md: 'row' }}
                spacing={2}
                alignItems={{ xs: 'flex-start', md: 'center' }}
                justifyContent="space-between"
            >
                <Box>
                    <Typography variant="h4" sx={{ fontWeight: 900, letterSpacing: 0.2 }}>
                        Zugeordnete Vorgänge
                    </Typography>
                    <Typography variant="subtitle1" sx={{ mt: 0.5 }}>
                        Bereits zugeordnete Bank- und PayPal-Vorgänge im Blick behalten.
                    </Typography>
                </Box>
                <Button
                    variant="outlined"
                    startIcon={<RefreshRoundedIcon />}
                    onClick={onRefresh}
                    disabled={isRefreshing}
                >
                    Aktualisieren
                </Button>
            </Stack>
        </Container>
    </Box>
);

export default AssignedTransactionsHeader;
